
import {Component, Vue, Watch} from 'vue-property-decorator';
import {sysRuleApi} from "@/api/sysRule";
@Component({
  name: "sys_rule_detail",
})
export default class Home extends Vue {
  fullScreen = false;
  private closePage: any;
  mode = "";
  id = 0
  form = {
    title: '',
    content: '',
  }
  rules = {
    title: [{required: true, message: '请输入公告标题', trigger: 'blur'}],
    content: [{required: true, message: '请输入公告内容', trigger: 'blur'}],
  }
  ckeditor = null as any;
  mounted() {
    const win = window as any;
    this.ckeditor = win.CKEDITOR.replace('editor1', {
      toolbarStartupExpanded: false,
      toolbar: [
          ['Undo', 'Redo', '-', 'SelectAll', 'RemoveFormat'],
          ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', 'Blockquote', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock'],
          ['Format', 'Font', 'FontSize'],
          ['TextColor', 'BGColor'],
          ['Bold', 'Italic', 'Underline', 'Strike', '-', 'Subscript', 'Superscript']
      ]
    });
    this.id = Number(this.$route.params.id);
    this.mode = this.$route.params.mode;
    if(this.mode !== 'Add') {
      this.getData();
    }
  }
  getData(){
    sysRuleApi.get(this.id).then((r: any) => {
      if(r.data.result === 0) {
        const {title, content} = r.data.data;
        this.form.title = title;
        this.form.content = content;
        this.$nextTick(() => {
          setTimeout(() => {
            this.ckeditor.setData(content);
            if(this.mode === 'View'){
              this.ckeditor.setReadOnly(true);
            }
          }, 500);
        });
      }
    });
  }
  saveData(){
    const content = this.ckeditor.getData();
    this.form.content = content;
    let form = this.$refs.form as HTMLFormElement;
    form.validate((valid: any) => {
      if(valid){
        sysRuleApi.edit({
          id: this.id,
          ...this.form
        }).then((r: any) => {
            if(r.data.result === 0){
              this.$message.success("保存成功！");
              this.closePage();
            }
        });
      }
    });
  }

  hasBtn(btnMode: string){
    if(btnMode === 'Save'){
      return this.mode !== 'View';
    }
  }
  // 销毁组件前，销毁编辑器
  beforeDestroy() {
    const win = window as any;
    win.CKEDITOR.instances['editor1'].destroy();
  }
}
